import React, { useEffect, useState } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang';
import { VariableProducts } from '../VariablesProducts';
import { useSelectorCustom } from '../../../../components/general/general-component/abstruct-component/useSelectorCustom';
import { loadOneProduct, putProduct } from '../../../../store/Actions/ActionProducts';
import { loadCategories, loadSubCategoriesByCategory } from '../../../../store/Actions/ActionCategory';
import { loadWarehouses } from '../../../../store/Actions/ActionWarehouses';
import ProductDescription from '../add-product/ProductDescription';
import InputsEditProduct from './InputsEditProduct';
import InnerLoader from '../../../../components/general/inner-loader/InnerLoader';

function EditProduct({ idEdit, open, setOpen, }) {
    const { dispatch, langLocal, navigate, mode } = AbstructVar()
    const { translate } = AbstructLang()
    const [optionCategories, setOptionCategories] = useState([])
    const [optionSubCategories, setOptionSubCategories] = useState([])
    const [optionWarehouse, setOptionWarehouse] = useState([])
    const { state, setStateCustom, setLoad, setState } = VariableProducts();
    const { one_product, loadingOneProduct, categories, sub_categories_by_category, warehouses } = useSelectorCustom()
    const [fields, setFields] = useState([{ name: '', description: '' }])
    useEffect(() => {
        dispatch(loadOneProduct(idEdit))
        dispatch(loadCategories())
        dispatch(loadWarehouses())
    }, [])
    useEffect(() => {
        setOptionCategories(categories?.map((category) => ({
            value: category?.id,
            label: category?.name
        })))
    }, [categories]);
    useEffect(() => {
        setOptionWarehouse(warehouses?.map((warehouse) => ({
            value: warehouse?.id,
            label: warehouse?.name
        })))
    }, [warehouses]);
    useEffect(() => {
        console.log(state.material_category_id)
        if (state.material_category_id !== "" && state.material_category_id !== undefined) {
            dispatch(loadSubCategoriesByCategory(state.material_category_id))
        }
    }, [state.material_category_id]);
    useEffect(() => {
        setOptionSubCategories(sub_categories_by_category?.map((i) => ({
            value: i.id,
            label: i.name
        })))
    }, [sub_categories_by_category]);
    useEffect(() => {
        console.log(one_product)
        if (!loadingOneProduct) {
            setState((prevState) => ({
                ...prevState,
                material_category_id: one_product?.material_category?.id,
                material_category_name: one_product?.material_category?.name,
                material_sub_category_id: one_product?.material_sub_category?.id,
                material_sub_category_name: one_product?.material_sub_category?.name,
                warehouse_id: one_product?.warehouse?.id,
                warehouse_name: one_product?.warehouse?.name,
                status: one_product?.status ? 'active' : "unactive",
                name: one_product?.name,
                type: one_product?.type,
                brand: one_product?.brand,
                model: one_product?.model,
                sn: one_product?.sn,
                description: one_product?.description,
                notes: one_product?.notes,
            }));
            setFields(one_product?.descriptions)
        }
    }, [one_product, loadingOneProduct])
    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(putProduct(idEdit, state, fields, setLoad));
    };
    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: `pop_center_edit_product ${mode === 'dark' ? "darkPopUp" : "lightPopUp"}`,
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className='edit-product' dir={langLocal == "ar" ? "rtl" : "ltr"} >
                {
                    !loadingOneProduct ?
                        <div className='inner-main' >
                            <h3 className={langLocal === 'ar' ? "textAlignRight" : ""} >{translate('edit_product')}</h3>
                            <p className={`basic-pro ${langLocal === 'ar' ? "textAlignRight" : ""}`} >{translate('basic_product_info')}</p>
                            <InputsEditProduct
                                optionCategories={optionCategories} state={state} optionSubCategories={optionSubCategories}
                                optionWarehouse={optionWarehouse} setStateCustom={setStateCustom} translate={translate}
                                langLocal={langLocal}
                            />
                            <ProductDescription langLocal={langLocal} fields={fields} setFields={setFields} />
                            <div style={langLocal === 'ar' ?{display: "flex",alignItems:"center"}:{}}>
                                <button className='btn_top_table' onClick={handleSubmit} style={{ marginTop: "20px" }} >
                                    {
                                        state?.Load ? "Loading ..." : translate('edit')
                                    }
                                </button>
                            </div>
                        </div> : <InnerLoader />
                }

            </div>
        </RModal>
    )
}

export default EditProduct